export default __webpack_public_path__ + "static/media/bb9.246448a1.png";